import EformBaseService from '../../../../services/EformBaseService'

export default class SbfiGesuchService extends EformBaseService {

  constructor() {
    super('wbf/sbfi/gesuch')
  }
}
